import { FetchOpportunityCardSettingsResponse, FetchOpportunitiesListPayload, FetchOpportunitiesListResponse, OpportunityCard } from './opportunitiesList.types';
import formatDateString from '../../../helpers/formatDate';
import { updatePaginationButtons } from '../pagination/pagination';
import copyToClipboard from '../../../helpers/copyToClipboard';
import axios from 'axios';

const opportunitiesList: HTMLDivElement = document.querySelector('.opportunities-list');

if (opportunitiesList) {
    const opportunitiesGrid = opportunitiesList.querySelector('.opportunities-list__grid') as HTMLDivElement;
    const opportunitiesFilters = opportunitiesList.querySelector('.opportunities-list__filters') as HTMLDivElement;
    const opportunitiesListSearchInput = opportunitiesList.querySelector('.opportunities-list__search-input') as HTMLInputElement;
    const nextPageButton = opportunitiesList.querySelector('.pagination__page-next') as HTMLButtonElement;
    const prevPageButton = opportunitiesList.querySelector('.pagination__page-prev') as HTMLButtonElement;
    const paginationDropdown = opportunitiesList.querySelector('.pagination__dropdown') as HTMLSelectElement;
    const paginationLast = opportunitiesList.querySelector('.pagination__page-last') as HTMLSelectElement;
    const paginationFirst = opportunitiesList.querySelector('.pagination__page-first') as HTMLSelectElement;
    const pagination = opportunitiesList.querySelector('.pagination') as HTMLDivElement;
    const radios: NodeListOf<HTMLInputElement> = opportunitiesList.querySelectorAll('.sort-filter__input');
    const currentCulture: string = document.documentElement.getAttribute('culture');

    let opportunityCards: OpportunityCard[] = [];
    let keyword: string = '';
    let sortBy: number = 1;
    let pageNumber: number = 1;
    let pageSize: number = +paginationDropdown?.value;
    let totalPages: number = 0;
    let totalCount: number = 0;
    let hasNextPage: boolean = false;
    let hasPreviousPage: boolean = false;
    let buttonsToShow: number = 3;
    let isLoading: boolean = false;
    let clickedNumber = null;
    let keywordChanged = false;

    let opportunityCardSettings: FetchOpportunityCardSettingsResponse = {
        cardButtonText: '',
        availableText: '',
        endText: '',
        noOpportunitiesText: '',
    };

    const fetchOpportunityCardSettings = async () => {
        try {
            const response = await axios.get<FetchOpportunityCardSettingsResponse>(
                `/api/opportunities/cardsettings?currentCulture=${currentCulture}`
            );

            opportunityCardSettings = response.data;
        } catch (error) {
            console.error(error);
        }
    };

    const fetchOpportunities = async (page = null) => {
        clickedNumber = page;
        pagination?.classList.add('hidden');

        if (clickedNumber) {
            pageNumber = page;
        }

        const url = new URL(window.location.href);

        pageNumber = keywordChanged ? 1 : Number(url.searchParams.get('pageNumber') || 1);
        pageSize = Number(url.searchParams.get('pageSize') || pageSize);
        keyword = keywordChanged ? keyword : url.searchParams.get('keyword') || '';
        sortBy = Number(url.searchParams.get('sortBy') || sortBy);

        paginationDropdown.value = pageSize.toString();
        opportunitiesListSearchInput.value = keyword;
        radios.forEach((radio) => {
            radio.checked = sortBy === +radio.value;
        });

        const payload: FetchOpportunitiesListPayload = {
            keyword,
            sortBy,
            pageNumber,
            pageSize,
            currentCulture,
        };

        isLoading = true;

        disableInputs();

        try {
            let response;
            if (
                (window.location.hostname === 'localhost' && window.location.port === '2000') ||
                window.location.hostname === 'mawhiba-fractal.netlify.app'
            ) {
                response = await axios.post<FetchOpportunitiesListResponse>(
                    'https://app-prd-umbracoportal-uaenorth-mawhiba-development.azurewebsites.net/api/opportunities',
                    payload
                );
            } else {
                response = await axios.post<FetchOpportunitiesListResponse>('/api/opportunities', payload);
            }
            opportunityCards = response.data.items;
            if (opportunityCards.length > 0) {
                pagination.classList.remove('hidden');
            }
            totalPages = response.data.totalPages;
            totalCount = response.data.totalCount;
            hasNextPage = response.data.hasNextPage;
            hasPreviousPage = response.data.hasPreviousPage;
        } catch (error) {
            console.error(error);
            enableInputs();
        } finally {
            updatePaginationButtons(
                totalPages,
                hasPreviousPage,
                hasNextPage,
                pageNumber,
                pageSize,
                totalCount,
                buttonsToShow,
                opportunityCards,
                renderPage,
                true
            );
            isLoading = false;
            updateCards();
            enableInputs();
        }
    };

    const updateCards = () => {
        opportunitiesGrid.innerHTML = '';

        if (opportunityCards.length === 0) {
            opportunitiesGrid.innerHTML = `<div class="flex" style="align-self: center;">${opportunityCardSettings.noOpportunitiesText}</div>`;
        } else {
            opportunityCards.forEach((card: OpportunityCard) => {
                const cardElement = document.createElement('a');

                cardElement.setAttribute('href', card.link);
                cardElement.className = 'opportunity-card flex flex--column';

                cardElement.innerHTML = `
                <div class="opportunity-card__content flex flex--column">
                    <p class='opportunity-card__title'>${card.title}</p>
                    <p class='opportunity-card__text'>${card.typeName}</p>
                </div>
                <div class="opportunity-card__items">
                    <p class='opportunity-card__info flex flex--align-center mb-2'>
                        <img src='/assets/img/img/user-octagon-icon.svg' alt='calendar icon' class='opportunity-card__icon' />
                        <span class='opportunity-card__info-text'>
                            ${card.methodName}
                        </span>
                    </p>
                    <p class='opportunity-card__info flex flex--align-center'>
                        <img src='/assets/img/img/calendar-icon-yellow.svg' alt='calendar icon' class='opportunity-card__icon' />
                        <span class='opportunity-card__info-text'>
                                ${formatDateString(card.startDate, false)}
                        </span>
                    </p>
                </div>
                <div class="opportunity-card__buttons flex flex--wrap flex--align-center flex--justify-between">
                    <div class="opportunity-card__link flex flex--align-center flex--justify-center">
                        ${opportunityCardSettings.cardButtonText}
                        <img src="/assets/img/img/arrow-top-left-dark.svg" alt="arrow icon" class="opportunity-card__link-icon">
                    </div>
                    <button class="button shareButton button--round-tiny opportunity-card__button opportunity-card__button-share flex flex--justify-center flex--align-center">
                        <img src="/assets/img/img/share-icon.svg" alt="share icon" class="button__image">
                    </button>
                </div>
            `;

                opportunitiesGrid.appendChild(cardElement);
            });

            addCardListeners();
        }
    };

    const disableInputs = () => {
        pagination?.classList.add('disabled');
        opportunitiesFilters?.classList.add('disabled');
    };

    const enableInputs = () => {
        pagination?.classList.remove('disabled');
        opportunitiesFilters.classList.remove('disabled');
    };

    paginationDropdown?.addEventListener('change', () => {
        pageSize = +paginationDropdown.value;
        pageNumber = 1;
        renderPage();
    });

    nextPageButton?.addEventListener('click', () => {
        pageNumber++;

        renderPage();
    });

    prevPageButton?.addEventListener('click', () => {
        pageNumber--;

        renderPage();
    });

    paginationFirst?.addEventListener('click', () => {
        pageNumber = 1;
        renderPage();
    });

    paginationLast?.addEventListener('click', () => {
        pageNumber = totalPages;
        renderPage();
    });

    let timeout = null;
    opportunitiesListSearchInput?.addEventListener('input', (e) => {
        clearTimeout(timeout);

        timeout = setTimeout(function () {
            keyword = opportunitiesListSearchInput.value.trim();
            keywordChanged = true;
            pageNumber = 1;
            fetchOpportunities();
        }, 1000);
    });

    radios.forEach((radio) => {
        // 1 = A-Z
        // 2 = Z-A

        radio.addEventListener('change', () => {
            const checkedRadio = opportunitiesList.querySelector(
                'input[name="sort-filter"]:checked',
            ) as HTMLInputElement;
            const checkedRadioValue = checkedRadio.value;
            sortBy = +checkedRadioValue;
            renderPage();
        });
    });

    const initializeEventsList = async () => {
        await fetchOpportunityCardSettings();
        await fetchOpportunities();
    };

    // Call the initialize function
    initializeEventsList();

    const addCardListeners = () => {
        const listCards: NodeListOf<HTMLAnchorElement> = opportunitiesList.querySelectorAll('.opportunity-card');

        if (listCards.length > 0) {
            const cardButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.opportunity-card__button');

            listCards.forEach((card) => {
                card.addEventListener('click', (e) => {
                    const target = e.target as HTMLElement;

                    if (target.classList.contains('button') || target.classList.contains('button__image')) {
                        e.preventDefault();
                    }
                });
            });

            cardButtons.forEach((button) => {
                button.addEventListener('click', (e) => {
                    if (button.classList.contains('shareButton')) {
                        copyToClipboard(button);
                    }
                });
            });
        }
    };

    const renderPage = (page = null) => {
        if (page) {
            pageNumber = page;
        }

        const url = new URL(window.location.href.replace(window.location.search, ''));
        url.searchParams.set('pageNumber', pageNumber.toString());
        url.searchParams.set('pageSize', pageSize.toString());
        if (keyword) url.searchParams.set('keyword', keyword);
        url.searchParams.set('sortBy', sortBy.toString());

         if (page == null)
        {
            window.location.href = url.toString();
        }
        return url.toString();
    };
}
